import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import UrbioticaParkinglocationsTable from '../components/UrbioticaParkinglocationsTable';
import UrbioticaParkinglocationsForm from '../components/UrbioticaParkinglocationsForm';

import UrbioticaParkinglocationsModel from '../components/UrbioticaParkinglocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Icon, DatePicker, message } from 'antd';

class UrbioticaParkinglocationsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    urbioticaParkinglocationsFormModalVisible: false,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    UrbioticaParkinglocationsModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }


  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Urbiotica - Seznam lokalit</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ urbioticaParkinglocationsFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <UrbioticaParkinglocationsForm
            type="modal"
            modalVisible={this.state.urbioticaParkinglocationsFormModalVisible}
            onModalCancel={() => { this.setState({ urbioticaParkinglocationsFormModalVisible: false }) }}
            onSuccess={(form, values) => {
              UrbioticaParkinglocationsModel.create(values)
                .then(() => {
                  message.success("Lokalita byla vložena!");
                  form.resetFields();
                  this.loadData();
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <UrbioticaParkinglocationsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }}
            onRemoveRow={(id) => {
              UrbioticaParkinglocationsModel.remove(id)
                .then(() => {
                  this.loadData();
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default UrbioticaParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/UrbioticaParkinglocationsScreen.js